import { Link } from 'react-router-dom';
import type { Manga } from '@/mocks/manga';

interface MangaCardProps {
  manga: Manga;
  showDesc?: boolean;
}

export default function MangaCard({ manga, showDesc = false }: MangaCardProps) {
  return (
    <Link to={`/manga/${manga.id}`} className="group block">
      <div className="relative overflow-hidden rounded-lg bg-background-100">
        <div className="aspect-[2/3] w-full overflow-hidden">
          <img
            src={manga.cover}
            alt={`${manga.title}漫画免费阅读封面`}
            title={`${manga.title}漫画免费阅读`}
            className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
        </div>
        <span className="absolute left-2 top-2 whitespace-nowrap rounded-md bg-primary-500 px-2 py-0.5 text-[11px] font-medium text-background-50">
          {manga.status}
        </span>
        <span className="absolute bottom-2 left-2 right-2 truncate rounded-md bg-foreground-950/60 px-2 py-1 text-[11px] text-background-50 backdrop-blur">
          {manga.latestChapter}
        </span>
        {manga.isHot && (
          <span className="absolute right-2 top-2 flex h-6 w-6 items-center justify-center rounded-full bg-secondary-500 text-xs text-background-50">
            <i className="ri-fire-fill" aria-hidden="true" />
          </span>
        )}
      </div>
      <h3 className="mt-2.5 truncate text-sm font-semibold text-foreground-950 transition-colors group-hover:text-primary-600 md:text-base">
        {manga.title}
      </h3>
      <div className="mt-1 flex items-center gap-3 text-xs text-foreground-600">
        <span className="flex items-center gap-1">
          <i className="ri-eye-line text-sm" aria-hidden="true" />
          {(manga.views / 10000).toFixed(1)}万
        </span>
        <span className="flex items-center gap-1 text-secondary-700">
          <i className="ri-star-fill" aria-hidden="true" />
          {manga.rating}
        </span>
        <span className="hidden sm:block">{manga.author}</span>
      </div>
      {showDesc && (
        <p className="mt-2 line-clamp-2 text-xs leading-relaxed text-foreground-600">
          {manga.description}
        </p>
      )}
    </Link>
  );
}